import * as Constants from 'client/util/Constants';
import { mapGetters, mapState } from 'vuex';

const {
  ItemTypeConsts,
  StoreModuleMap,
} = Constants;

const settingsModule = StoreModuleMap[ItemTypeConsts.settings];

export default {
  computed: {
    ...mapGetters(settingsModule, {
      isProvider: 'isProvider',
      user: 'getUser',
    }),

    ...mapState(settingsModule, ['orgId']),

    id() {
      return this.isProvider ? this.user.provider : this.orgId;
    },

    idLabel() {
      return this.isProvider ? 'Provider ID:' : 'Organization ID:';
    },
  },
};
